import React from 'react';
import cn from 'classnames';
import Contacts from 'components/UI/Contacts';
import { useLang, useTrans } from 'utils/localisation';
import OwnerInfo from './components/OwnerInfo';
import Description from './components/Description';
import Logos from './components/Logos';
import { getOwnerPosition } from 'utils/owners';
import { useOwnersInfo } from 'staticQueries/owners-info';

import * as styles from './ModalAside.module.scss';

export default function AsideWithOwner({ ownerData, className }) {
  const ownerInfo = useOwnersInfo(ownerData?.ownerDepartment);
  const { photo, name, position } = ownerInfo;
  const t = useTrans(['common', 'footer', 'getConsultation']);
  const lang = useLang();

  const ownerPosition = getOwnerPosition(position, lang);

  const contactUs = (
    <>
      <p className={styles.sectionTitle}>{t('contactUs')}</p>
      <Contacts className={styles.contacts} />
    </>
  );

  const customers = (
    <>
      <p className={styles.sectionTitle}>{t('clientsWhoTrustUs')}</p>
      <Logos />
    </>
  );

  return (
    <div className={cn(styles.wrapper, className)}>
      <section className={styles.section}>
        <OwnerInfo photo={photo} position={ownerPosition} name={name} />
        <Description description={ownerData?.description} />
      </section>
      <section className={styles.section}>{contactUs}</section>
      <section className={styles.section}>{customers}</section>
    </div>
  );
}
